import { copyOutline } from 'ionicons/icons';
import { ReactElement } from 'react';
import { getLocalizedText } from '../../../../../../i18n/i18n.utils';
import { useClipboardContext } from '../../../hook/clipboard.hooks';
import { ApplicationClipboardPath, FlowItem } from '../../../model/flow.types';
import { FlowItemBaseAction } from './flow-item-base-action';

interface FlowItemCopyActionProps {
  items: FlowItem[];
  label?: string;
  onCopy?: () => void;
}

const FlowItemCopyAction = (props: FlowItemCopyActionProps): ReactElement => {
  const { onCopy, items, label } = props;

  const { copy: copyItems } = useClipboardContext();

  return (
    <FlowItemBaseAction
      icon={copyOutline}
      label={label ?? getLocalizedText('common:copy')}
      onClick={() => {
        copyItems(ApplicationClipboardPath.FLOW_ITEMS, items);
        if (onCopy) {
          onCopy();
        }
      }}
    />
  );
};

export { FlowItemCopyAction };
